import { Team } from "resource-planner-model";
import {
  FETCH_TEAMS,
  LOAD_TEAMS,
  PERSIST_TEAM,
  REMOVE_TEAM,
  REMOVE_TEAM_LOCAL,
  TeamAction,
  TeamsState,
  UPSERT_TEAM
} from "./TeamsTypes";

const initialState: TeamsState = {
  items: {},
  loadedAll: false,
  nextToken: undefined,
  synching: false,
};

export default function teamsReducer(
  state = initialState,
  action: TeamAction
): TeamsState {
  switch (action.type) {
    case FETCH_TEAMS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_TEAM:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_TEAM:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_TEAM_LOCAL: {
      const items = { ...state.items };
      delete items[action.id];
      return {
        ...state,
        items,
        synching: false,
      };
    }
    case UPSERT_TEAM:
      return {
        ...state,
        items: {
          ...state.items,
          [action.item.id]: action.item,
        },
        synching: false,
      };
    case LOAD_TEAMS: {
      const items = action.items.reduce((all: { [id: string]: Team }, team) => {
          // Filter out teams with offboardingDate older than a year
          const oneYearAgo = new Date();
          oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

          // Only add the team if they don't have an offboardingDate or it's less than a year old
          if (!team.offboardingDate || (
            team.offboardingDate &&
            new Date(team.offboardingDate.year, team.offboardingDate.month - 1, team.offboardingDate.day) >= oneYearAgo
          )) {
            all[team.id] = team;
          }
        return all;
      }, action.append ? { ...state.items } : {});
      return {
        ...state,
        items,
        loadedAll: action.loadedAll || false,
        nextToken: action.nextToken,
        synching: false,
      };
    }
    default:
      return state;
  }
}
